import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TranslationService } from '../translation.service';

@Injectable()
export class LanguageHttpInterceptor implements HttpInterceptor {
    private readonly translationService = inject(TranslationService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!!this.translationService.getCurrent && !!this.translationService.getCurrent()) {
            const languageRequest = request.clone({
                headers: request.headers.set('Accept-Language', this.translationService.getCurrent().code)
            });

            return next.handle(languageRequest);
        }

        return next.handle(request);
    }
}
